module.exports = __webpack_public_path__ + "static/media/icon_contact.406c2fd4.svg";